import { ThemeOptions, createTheme } from "@mui/material";
import { mui } from "./brand";
import { palette } from "../styles/design-tokens";

export const muiThemeOptions: ThemeOptions = {
  button: {
    main: palette["red-58"],
  },
  typography: {
    fontFamily: mui.fontBody,
  },
  palette: {
    primary: {
      main: mui.primary,
      contrastText: mui.primaryContrast,
    },
    secondary: {
      main: mui.secondary,
      contrastText: mui.secondaryContrast,
    },
  },
};

export const muiTheme = createTheme(muiThemeOptions);
